import * as React from 'react';
import createSVGIcon from '../utils/createSVGIcon';

export default createSVGIcon(() => {
  return (
    <path d="M271 256L509 17a10 10 0 0 0-14-14L256 241 18 3A10 10 0 0 0 3 17l239 239L3
     494a10 10 0 1 0 15 15l238-239 239 239a10 10 0 0 0 14-15z"/>
  );
}, '0 0 512 512');
